import { render, staticRenderFns } from "./SupplierManufacturingHygiene.vue?vue&type=template&id=4c80317a&scoped=true&"
import script from "./SupplierManufacturingHygiene.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingHygiene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80317a",
  null
  
)

export default component.exports